import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { WaybillOverviewData } from '../../models/waybill-overview.model';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ShipmentWaybillEndpoint } from '../../constants';

@Injectable({ providedIn: 'root' })
export class WaybillOverviewService {
  constructor(private http: WrapperHttpService) {}

  getOverview(internalWaybillId: string): Observable<WaybillOverviewData> {
    return this.http
      .withLoading()
      .get<WaybillOverviewData>(
        `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
          ShipmentWaybillEndpoint.Overview
        }?${getQueryStringFromObject({ internalWaybillId })}`,
      );
  }
}
